// extracted by mini-css-extract-plugin
export default {"terms-footer":"terms-footer--xrnQZ","termsFooter":"terms-footer--xrnQZ"};